import styled from 'styled-components';
import { buttonBase } from '../styled.js';
import { getToggleButtonAppearance } from '../utils/getToggleButtonAppearance.js';
import { getButtonSize } from '../utils/getButtonSize.js';

var ToggleButton = styled.button.attrs(function (props) {
  return Object.assign(Object.assign({}, props), {
    $stretch: props.stretch || props.$stretch,
    $toggled: props.toggled || props.$toggled
  });
}).withConfig({
  displayName: "ToggleButton",
  componentId: "sc-sc7o2h-0"
})(["", ";width:", ";z-index:", ";", " ", ";"], buttonBase, function (props) {
  return props.$stretch && "100%;";
}, function (props) {
  return props.$toggled && "1;";
}, function (props) {
  return getToggleButtonAppearance(props.appearance, props.$toggled);
}, function (props) {
  return getButtonSize(props.size);
});

export { ToggleButton };
